import { createApp } from 'vue'
import App from './App.vue'
import { useMainStore } from './stores/useMainStore.js'
import { useRechnerStore } from './stores/rechner.js'
import { useAntragStore } from './stores/antrag.js'
import { useDokStore } from './stores/dok.js'
import { useVertragStore } from './stores/vertrag.js'

import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import "@fontsource/source-sans-pro"
import "@fontsource/source-sans-pro/700.css";
import "@fontsource/source-sans-pro/600.css";

import './styles/globalvigotr.scss'

export function mount(el) {
  const target = typeof el === 'string' ? document.querySelector(el) : el
  if (!target) throw new Error('Mount-Element nicht gefunden')

  const app = createApp(App)
  const pinia = createPinia()
  pinia.use(piniaPersist)
  app.use(pinia)
  
  const mainStore = useMainStore()
  mainStore.setDataAttributes(target)

  // Konsistenzprüfung: nur wenn rechner bereits gesetzt war (kein Erstladen)
  const rechnerStore = useRechnerStore()
  const aktuellerRechner = mainStore.rechner

  if (rechnerStore.rechner !== '') {
    const rechnerGewechselt = rechnerStore.rechner !== aktuellerRechner
    const abgeschlossen    = rechnerStore.stepStatus === 5

    if (rechnerGewechselt || abgeschlossen) {
      rechnerStore.cleanUpStore()
      useAntragStore().resetAntrag()
      useDokStore().initializeStore()
      useVertragStore().resetVertrag()
    }
  }

  // rechner.rechner immer mit aktuellem Wert aus data-Attribut befüllen
  rechnerStore.rechner = aktuellerRechner

  const vm = app.mount(target)

  if (window.bootstrap && target.querySelectorAll) {
    target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((node) => {
      new window.bootstrap.Tooltip(node, { container: target })
    })
  }
  return app
}

export function autoMount() {
  document.querySelectorAll('[data-vigotr]').forEach((host) => {
    mount(host)
  })
}

// Automatisch mounten (Development und Production)
if (typeof window !== 'undefined') {
  // Warte auf DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      autoMount()
    })
  } else {
    autoMount()
  }
  
  // Zusätzlich global verfügbar machen für manuelle Nutzung
  window.vigoTR = { mount, autoMount }
}
